import { render, staticRenderFns } from "./GoalMemberConfig.vue?vue&type=template&id=4a1627a7&"
import script from "./GoalMemberConfig.vue?vue&type=script&lang=js&"
export * from "./GoalMemberConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports